/**
 * Export Templates
 */
export { default as Pricing } from './pricing';
export { default as ShowcaseStyle1 } from './showcase-style-1';
export { default as ShowcaseStyle2 } from './showcase-style-2';
export { default as ShowcaseStyle3 } from './showcase-style-3';
